import React, { useState, useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { useHistory, Redirect, Link } from "react-router-dom";
import { Helmet } from "react-helmet";

function ShareKingdom(props) {
    const [cookies] = useCookies(['user']);
	const user_id = cookies.user_id;
	const token = cookies.token;
    const { state } = props.location
	const [allData] = useState(state[0]);
    const [shareData] = useState(state[1]);
    let history = useHistory();
    const [kds, setKds] = useState([]);
    const [error1, setError] = useState(false);
    // const [msg, setMsg] = useState("");
    const [button, setButton] = useState("");
    const [red, setRed] = useState("");
    const row = [];
    useEffect(() => {
		getUserData();
	}, []);

    const getUserData = async () => {
        const row = [];
        for (const [index, value] of allData.kingdoms.entries()) {
            if(value.kd_id !== shareData.kd_id && shareData.level === value.level){
                var card =
                <div className="col-12" key={index} >
                    <div className="button-group">
                        <a className="btn btn-red btn-block btn-lg mb-2"  style={{backgroundImage: `url(${value.kd_image})`,backgroundSize: `100% 100%`}} data-toggle="modal" data-target="#bottom_modal" onClick={() => setChatMsg(value)}>
                            {"Kingdom " + value.kd_name}
                            <img src={require("./../images/share-kd-right.png").default} alt="rarrow" className="img-fluid" />
                        </a>
                    </div>
                </div>; 
                row.push(card);
            }
        }
        if(row.length > 0){
            setKds(row);
        } else {
            setKds(<i style={{textAlign:`center`, color:`red`, margin:`20px`}}>You have no other kingdom at same level as kingdom {" " + shareData.kd_name}.</i>);
        }
    }

    const search = async (param) => {
        const k =[];
        for (const [index, value] of allData.kingdoms.entries()) {
            if(value.kd_id !== shareData.kd_id && shareData.level === value.level){
                let name = value.kd_name;
                let name2 = "kingdom " + value.kd_name;
                name = name.toLowerCase();
                name2 = name2.toLowerCase();
                if (name.includes(param.toLowerCase()) || name2.includes(param.toLowerCase())) {
                    var card =
                    <div className="col-12" key={index} >
                        <div className="button-group">
                            <a className="btn btn-red btn-block btn-lg mb-2"  style={{backgroundImage: `url(${value.kd_image})`,backgroundSize: `100% 100%`}} data-toggle="modal" data-target="#bottom_modal" onClick={() => setChatMsg(value)}>
                                {"Kingdom " + value.kd_name}
                                <img src={require("./../images/share-kd-right.png").default} alt="rarrow" className="img-fluid" />
                            </a>
                        </div>
                    </div>;
                    k.push(card);
                }
            }
        }
        if (k.length > 0){
            setKds(k);
        } else {
            setKds(<i style={{textAlign:`center`, color:`red`, margin:`20px`}}>You have no other kingdom at same level as kingdom {" " + shareData.kd_name}.</i>);
        }
    }

    async function shareChat(data, msg){
        const requestOptions = {
            method: 'POST',
			headers: { 'Content-Type': 'application/json','token':token,'userId':user_id},
			body: JSON.stringify({dist_user_id:user_id,kd_id:data.kd_id,get_stats:"false"}),
		};
        
		const response	 = await fetch(process.env.REACT_APP_BKB_URL_DOMAIN + 'get-kingdom-details', requestOptions);
		const resp = await response.json();
		if (resp.status !== "success"){
            setError(true);
		}
        localStorage.setItem('chat_users', JSON.stringify(resp.chat_data));
        localStorage.setItem('cg_id', JSON.stringify(resp.cg_id));
        setRed(<Redirect to={{
			pathname:"/chat",
			state: [data,"send",msg]
		}}  />);
    }

    function setChatMsg(data){
        setButton("");
        let m = "Check out kingdom "+shareData.kd_name+". Lets's go to war them.";
        let btn = <div className="row">
            <div className="col-6">
                <a className="button-red" data-dismiss="modal" aria-label="Close">No</a>
            </div>
            <div className="col-6">
                <a className="button-green" data-dismiss="modal" aria-label="Close" onClick={() => shareChat(data, m)} >Yes</a>
            </div>
        </div>;
        setButton(btn);
    }

    return (
<>
	<Helmet link={
		[{"rel": "stylesheet", "href": 'css/share-kingdoms.css'}]
	}/>
    { error1 === true && (
        	<Redirect to='/'  />
	)}
    <div className="row no-gutters">
        <div className="application">
            <div  style={{
					overflowY: 'scroll',
					overflowX: `hidden`,
					height: `100vh` ,
					width: `100%`}} >
                <div className="bg-gradient1">
                    <div className="appHeader bg-transparent text-light position-relative">
                        <div className="left">
                            <a className="headerButton goBack" onClick={() => history.goBack()} >
                                <img src={require("./../images/faq-icon.png").default} alt="back"  className="img-fluid" />
                            </a>
                        </div>
                        <div className="right">
                            <div className="headerButton">
                                <Link to="/faq">
                                    <img src={require("./../images/faq.png").default} alt="faq" className="img-fluid" />
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="search">
                    <div className="input-group sendmessage align-self-center">
                        <div className="input-group-append">
                            <div className="input-group-text p-2"><img src={require("./../images/search.png").default} alt=""/></div>
                        </div>
                        <textarea className="form-control" rows="1" onChange={e => search(e.target.value)}  aria-label="With textarea" placeholder="Search User & Kingdoms" ></textarea>
                    </div>
                </div>

                <div className="section kingdom-availabel">
                    <div className="kingdom-war">
                        <div className="row mx-auto p-0">
                            {kds}
                        </div>                
                    </div>
                </div>

            </div>
        </div>

        <div className="modal bottom fade" id="bottom_modal" tabIndex="-1" role="dialog" aria-labelledby="bottom_modal">
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-header border-0 px-26 text-center d-block" style={{height: `50px`}}>
                        <h5 className="modal-title">Are you sure ?</h5>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close" style={{opacity: `1`,position: `relative`,top: `-20px`}}>
                            <img src={require("./../images/close.png").default} alt="close" className="img-fluid" />
                        </button>
                    </div>
                    <div className="modal-body px-34" style={{minHeight:`100px`}}>
                        {/* <div className="row">
                            <div className="col-6">
                                <a className="button-red" data-dismiss="modal" aria-label="Close">No</a>
                            </div>
                            <div className="col-6">
                                <a className="button-green" onClick={() => shareChat(value)} >Yes</a>
                            </div>
                        </div> */}
                        {button}
                    </div>
                </div>
            </div>
        </div>
        {red}
        <div className="bg"></div>
    </div>
</>
    );
}

export default ShareKingdom;
